/**
 * Returns a timeseires dataset by id
 * @param {Number} id: Id of the desired dataset
 * @returns {Dict} Metadata containing the time series data and suplemental metadata
 */
const getDatasetById = (id) => {
  let metadata = null;
  switch (id) {
    case 0:
      metadata = {
        title: 'Monthly totals of international airline passengers.',
        lambda_: 0.14802265137037945,
        description: 'International airline passengers (in thousands). January 1949 - December 1960.',
        frequency: 12,
        data: [112, 118, 132, 129, 121, 135, 148,
          148, 136, 119, 104, 118, 115, 126, 141,
          135, 125, 149, 170, 170, 158, 133, 114,
          140, 145, 150, 178, 163, 172, 178, 199,
          199, 184, 162, 146, 166, 171, 180, 193,
          181, 183, 218, 230, 242, 209, 191, 172,
          194, 196, 196, 236, 235, 229, 243, 264,
          272, 237, 211, 180, 201, 204, 188, 235,
          227, 234, 264, 302, 293, 259, 229, 203,
          229, 242, 233, 267, 269, 270, 315, 364,
          347, 312, 274, 237, 278, 284, 277, 317,
          313, 318, 374, 413, 405, 355, 306, 271,
          306, 315, 301, 356, 348, 355, 422, 465,
          467, 404, 347, 305, 336, 340, 318, 362,
          348, 363, 435, 491, 505, 404, 359, 310,
          337, 360, 342, 406, 396, 420, 472, 548,
          559, 463, 407, 362, 405, 417, 391, 419,
          461, 472, 535, 622, 606, 508, 461, 390,
          432],
        start: '1949-01',
        end: '1960-12',
      };

      break;
    case 1:
      metadata = {
        lambda_: null,
        title: 'US Electricity Monthly Total Net Generation',
        description: 'US Electricity monthly total net generation (in billions of kilowatt hours). January 1973 - June 2013.',
        frequency: 12,
        data: [160.218, 143.539, 148.158, 139.589, 147.395, 161.244, 173.733,
          177.365, 156.875, 154.197, 148.138, 153.605, 157.555, 142.748,
          150.342, 142.312, 153.813, 156.44, 178.247, 174.119, 152.467,
          152.196, 150.071, 160.009, 164.623, 147.349, 155.76, 146.495,
          153.531, 162.717, 177.057, 179.931, 155.441, 155.188, 153.035,
          169.628, 178.609, 156.966, 164.467, 153.467, 157.664, 173.674,
          186.691, 186.639, 165.237, 164.009, 169.346, 184.144, 196.665,
          162.949, 169.437, 157.117, 169.596, 181.031, 199.168, 196.363,
          176.498, 166.645, 167.388, 184.589, 198.108, 173.746, 173.461,
          160.013, 175.549, 188.585, 202.947, 206.659, 185.802, 176.013,
          176.389, 192.105, 209.987, 186.587, 183.154, 170.26, 178.409,
          186.976, 202.522, 205.101, 180.975, 179.953, 177.77, 188.97,
          200.296, 188.961, 187.745, 169.017, 176.066, 189.748, 217.058,
          215.629, 191.698, 178.761, 178.771, 195.849, 206.758, 179.86,
          185.834, 172.841, 178.139, 203.021, 220.655, 210.639, 187.051,
          181.558, 175.792, 195.826, 209.694, 180.546, 187.968, 172.877,
          177.48, 186.447, 210.865, 205.892, 180.875, 173.172, 173.599,
          184.958, 195.871, 172.725, 182.769, 170.669, 174.725, 191.367,
          220.447, 230.193, 195.817, 183.137, 183.171, 212.555, 216.924,
          189.81, 200.387, 181.381, 192.55, 209.967, 221.526, 229.532,
          195.411, 191.142, 190.602, 200.232, 228.148, 198.488, 195.25,
          185.173, 197.123, 205.682, 227.004, 226.286, 202.712, 194.995,
          192.649, 219.49, 217.761, 192.582, 197.115, 186.37, 197.647,
          215.334, 242.954, 225.402, 206.905, 197.96, 196.654, 213.787,
          223.041, 194.281, 202.13, 189.792, 206.407, 225.908, 248.196,
          247.881, 213.221, 203.215, 200.479, 220.736, 238.188, 217.183,
          214.294, 196.297, 208.704, 233.066, 257.742, 267.929, 220.392,
          210.814, 209.815, 232.988, 246.766, 233.783, 241.946, 222.869,
          234.825, 250.919, 273.458, 275.42, 242.794, 235.669, 234.25,
          274.448, 255.187, 229.499, 244.761, 229.77, 241.774, 268.992,
          287.448, 290.655, 258.357, 244.372, 231.242, 255.77, 269.214,
          228.29, 240.561, 227.799, 254.873, 269.099, 294.648, 292.159,
          256.027, 245.378, 241.661, 254.089, 267.773, 239.514, 247.733,
          233.406, 242.412, 261.077, 293.617, 281.927, 259.925, 244.994,
          244.162, 267.343, 271.021, 248.015, 261.248, 234.695, 244.326,
          275.36, 312.225, 311.45, 264.032, 250.553, 252.102, 272.165,
          289.768, 249.172, 257.998, 240.637, 252.745, 294.162, 311.257,
          307.605, 266.262, 256.528, 251.868, 269.52, 279.773, 252.307,
          261.343, 244.736, 264.288, 286.258, 330.416, 345.78, 277.575,
          263.978, 261.478, 285.554, 296.923, 270.685, 275.019, 251.613,
          282.266, 302.717, 327.708, 329.286, 283.151, 271.446, 269.122,
          284.25, 300.574, 258.131, 272.258, 258.284, 272.914, 299.092,
          344.516, 332.899, 301.057, 284.971, 271.121, 296.356, 295.26,
          260.59, 286.878, 261.23, 299.64, 328.903, 361.936, 357.366,
          318.924, 284.446, 267.136, 297.986, 315.814, 274.82, 298.145,
          280.719, 300.098, 328.924, 376.538, 364.031, 305.516, 283.935,
          271.096, 295.174, 327.994, 294.169, 301.58, 285.578, 322.954,
          339.054, 356.528, 368.669, 312.447, 289.452, 284.67, 319.011,
          332.493, 282.94, 300.707, 278.079, 300.492, 327.694, 357.614,
          370.533, 306.929, 294.734, 278.934, 305.496, 319.941, 281.826,
          302.549, 289.848, 307.675, 341.023, 381.542, 374.586, 331.279,
          307.059, 296.29, 324.834, 341.989, 299.249, 304.317, 285.756,
          307.545, 328.694, 374.396, 381.816, 323.136, 306.741, 297.867,
          331.68, 346.546, 314.28, 308.812, 290.56, 327.38, 345.085,
          377.332, 368.439, 335.622, 312.45, 302.101, 341.948, 343.121,
          298.5, 317.458, 289.562, 315.062, 363.672, 402.274, 404.941,
          350.218, 316.398, 306.115, 348.101, 328.658, 307.333, 318.73,
          297.858, 330.616, 364.26, 410.421, 407.763, 332.055, 321.567,
          309.159, 336.283, 353.531, 323.23, 320.471, 303.129, 330.203,
          362.755, 393.226, 421.797, 355.394, 332.615, 314.103, 346.29,
          362.998, 325.106, 324.63, 305.865, 325.245, 373.109, 402.9,
          388.987, 338.056, 318.547, 310.046, 343.898, 354.993, 300.887,
          310.603, 289.537, 311.306, 347.658, 372.542, 381.221, 327.401,
          307.04, 296.635, 350.507, 360.957, 319.735, 312.168, 287.8,
          327.936, 375.759, 409.725, 408.884, 346.045, 307.921, 306.01,
          362.119, 363.105, 313.293, 318.71, 302.4, 323.627, 367.727,
          418.693, 406.541, 337.961, 308.727, 304.119, 335.753, 340.919,
          310.151, 309.04, 295.94, 337.53, 361.506, 416.515, 396.108,
          334.735, 312.157, 305.548, 334.335, 348.642, 309.601, 325.372,
          298.261, 322.118, 356.4],
        start: '1973-01',
        end: '2013-06',
      };
      break;
    case 2:
      metadata = {
        title: 'UK Quarterly Gas Consumption',
        lambda_: -0.29438615381988975,
        description: 'Quarterly UK gas consumption (in millions of therms). 1960 Q1 - 1986 Q4',
        frequency: 4,
        data: [160.1, 129.7, 84.8, 120.1, 160.1, 124.9, 84.8, 116.9,
          169.7, 140.9, 89.7, 123.3, 187.3, 144.1, 92.9, 120.1,
          176.1, 147.3, 89.7, 123.3, 185.7, 155.3, 99.3, 131.3,
          200.1, 161.7, 102.5, 136.1, 204.9, 176.1, 112.1, 140.9,
          227.3, 195.3, 115.3, 142.5, 244.9, 214.5, 118.5, 153.7,
          244.9, 216.1, 188.9, 142.5, 301.0, 196.9, 136.1, 267.3,
          317.0, 230.5, 152.1, 336.2, 371.4, 240.1, 158.5, 355.4,
          449.9, 286.6, 179.3, 403.4, 491.5, 321.8, 177.7, 409.8,
          593.9, 329.8, 176.1, 483.5, 584.3, 395.4, 187.3, 485.1,
          669.2, 421.0, 216.1, 509.1, 827.7, 467.5, 209.7, 542.7,
          840.5, 414.6, 217.7, 670.8, 848.5, 437.0, 209.7, 701.2,
          925.3, 443.4, 214.5, 683.6, 917.3, 515.5, 224.1, 694.8,
          989.4, 477.1, 233.7, 730.0, 1087.0, 534.7, 281.8, 787.6,
          1163.9, 613.1, 347.4, 782.8],
        start: '1960-01',
        end: '1986-10',
      };
      break;

    case 3:
      metadata = {
        title: 'Quarterly Australian Beer Production',
        lambda_: null,
        description: 'Total quarterly beer production in Australia (in megalitres). 1956 Q1 - 2008 Q3.',
        frequency: 4,
        data: [284, 213, 227, 308, 262, 228, 236, 320, 272, 233, 237, 313, 261,
          227, 250, 314, 286, 227, 260, 311, 295, 233, 257, 339, 279, 250,
          270, 346, 294, 255, 278, 363, 313, 273, 300, 370, 331, 288, 306,
          386, 335, 288, 308, 402, 353, 316, 325, 405, 393, 319, 327, 442,
          383, 332, 361, 446, 387, 357, 374, 466, 410, 370, 379, 487, 419,
          378, 393, 506, 458, 387, 427, 565, 465, 445, 450, 556, 500, 452,
          435, 554, 510, 433, 453, 548, 486, 453, 457, 566, 515, 464, 431,
          588, 503, 443, 448, 555, 513, 427, 473, 526, 548, 440, 469, 575,
          493, 433, 480, 576, 475, 405, 435, 535, 453, 430, 417, 552, 464,
          417, 423, 554, 459, 428, 429, 534, 481, 416, 440, 538, 474, 440,
          447, 598, 467, 439, 446, 567, 485, 441, 429, 599, 464, 424, 436,
          574, 443, 410, 420, 532, 433, 421, 410, 512, 449, 381, 423, 531,
          426, 408, 416, 520, 409, 398, 398, 507, 432, 398, 406, 526, 428,
          397, 403, 517, 435, 383, 424, 521, 421, 402, 414, 500, 451, 380,
          416, 492, 428, 408, 406, 506, 435, 380, 421, 490, 435, 390, 412,
          454, 416, 403, 408, 482, 438, 386, 405, 491, 427, 383, 394, 473,
          420, 390, 410, 488, 415, 398, 419, 488, 414, 374],
        start: '1956-01',
        end: '2010-04',
      };
      break;
    default:
      break;
  }
  return metadata;
};

export default getDatasetById;
